import React, { useState } from "react";
import { Popover, Typography } from "@mui/material";
import { Button, Checkbox } from "antd";
import "./FilterPopover.scss";

const FilterPopover = ({
  open,
  anchorEl,
  onClose,
  filterOptions = [],
  selectedFilters = {},
  onFilterChange,
  onClearAll,
  isSmallScreen = false,
  translations = {
    clear: "Clear",
    apply: "Apply",
    notFound: "No options found",
  },
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "right",
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "right",
  },
}) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(-1);
  const [filterSearchText, setFilterSearchText] = useState("");

  const handleDropdownToggle = (index) => {
    setOpenDropdownIndex(index === openDropdownIndex ? -1 : index);
    setFilterSearchText("");
  };

  const handleClose = () => {
    setOpenDropdownIndex(-1);
    setFilterSearchText("");
    onClose();
  };

  const handleClearAll = () => {
    if (onClearAll) {
      onClearAll();
    }
    handleClose();
  };

  const handleApply = () => {
    handleClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        className: "filter-popover-paper",
        style: {
          marginTop: "8px",
          minWidth: isSmallScreen ? "90vw" : "280px",
          maxWidth: isSmallScreen ? "95vw" : "420px",
          borderRadius: 20,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.9) 100%)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,0.2)",
          boxShadow:
            "0 20px 40px rgba(98,100,167,0.15), 0 8px 16px rgba(0,0,0,0.06)",
          overflow: "visible",
          padding: 0,
        },
      }}
      disablePortal={false}
      keepMounted={false}
    >
      <div className="filter-popover-content">
        <div className="filter-options">
          {filterOptions.map((option, index) => {
            const isOpenDropDown = index === openDropdownIndex;
            
            // Handle both data formats: option.label (array of strings) or option.options (array of objects)
            const optionsList = option.label || (option.options ? option.options.map(opt => opt.label || opt.value || opt) : []);
            const filteredOptions = optionsList.filter((o) => {
              const searchText = typeof o === 'string' ? o : (o.label || o.value || String(o));
              return searchText.toLowerCase().includes(filterSearchText.toLowerCase());
            });

            return (
              <div key={option.id} className="filter-option-group">
                <div
                  className="filter-option-header"
                  onClick={() => handleDropdownToggle(index)}
                >
                  <Typography className="filter-option-title">
                    {option.title}
                  </Typography>
                  {selectedFilters[option.id] &&
                    selectedFilters[option.id].length > 0 && (
                      <span className="filter-count-badge">
                        {selectedFilters[option.id].length}
                      </span>
                    )}
                </div>

                {isOpenDropDown && (
                  <div className="filter-dropdown-content">
                    {option.search && (
                      <div className="filter-search-container">
                        <input
                          type="search"
                          placeholder={`Search ${option.title}`}
                          value={filterSearchText}
                          onChange={(e) => setFilterSearchText(e.target.value)}
                          className="filter-search-input"
                        />
                      </div>
                    )}

                    <div className="filter-options-list">
                      {filteredOptions.length > 0 ? (
                        filteredOptions.map((item, i) => {
                          const label = typeof item === 'string' ? item : (item.label || item.value || String(item));
                          const value = typeof item === 'string' ? item : (item.value || item.label || String(item));
                          
                          return (
                          <div key={i} className="filter-option-item">
                            <Checkbox
                              checked={
                                selectedFilters[option.id]?.includes(value) ||
                                false
                              }
                              onChange={(e) =>
                                onFilterChange(
                                  option.id,
                                  value,
                                  e.target.checked
                                )
                              }
                              className="filter-checkbox"
                            />
                            <label
                              className="filter-option-label"
                              onClick={(e) => {
                                e.preventDefault();
                                onFilterChange(
                                  option.id,
                                  value,
                                  !selectedFilters[option.id]?.includes(value)
                                );
                              }}
                            >
                              {label}
                            </label>
                          </div>
                          );
                        })
                      ) : (
                        <div className="filter-no-options">
                          <p>{translations.notFound}</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="filter-actions">
          <Button
            type="link"
            onClick={handleClearAll}
            className="filter-clear-btn"
          >
            {translations.clear}
          </Button>
          <Button
            type="primary"
            onClick={handleApply}
            className="filter-apply-btn"
          >
            {translations.apply}
          </Button>
        </div>
      </div>
    </Popover>
  );
};

export default FilterPopover;
